const defaultTotalsConfig = {
  BillingAddressId: '',
  ShippingAddressId: '',
  ShippingMethodName: '',
  ShippingRateComputationMethodSystemName: '',
  PickUpInStoreId: '',
  PaymentMethodSystemName: '',
  TermsOfServiceOnOrderConfirmPage: false,
};

const getters = {
  cart: (state) => state.cart,
  isCartLoading: (state) => state.isCartLoading,
  defaultTotalsConfig: () => defaultTotalsConfig,
  totals: (state) => state.totals,
  isTotalsLoading: (state) => state.isTotalsLoading,
  paymentMethods: (state) => state.paymentMethods,
  shippingMethods: (state) => state.shippingMethods,
  shippingAddress: (state) => state.shippingAddress,
};

export default getters;
